import ValidationResult from "domain/types/global/validationResult";
import {
	CAMPANHA_RESGATE_APROVAR,
	CAMPANHA_RESGATE_APROVAR_BULK,
	CAMPANHA_RESGATE_REPROVAR_BULK,
	AprovarPedidoActionTypes,
	AprovarPedidoState
} from "../../../types/aprovarPedido/aprovarPedido";

const INITIAL_STATE: AprovarPedidoState = {
	mudancaStatus: {} as ValidationResult,
	mudancaStatusBulk: null,
}

export function AprovarPedidoReducer(state = INITIAL_STATE, action: AprovarPedidoActionTypes): AprovarPedidoState {
	switch (action.type) {
		case CAMPANHA_RESGATE_APROVAR:
			return { ...state, mudancaStatus: action.payload };
		case CAMPANHA_RESGATE_APROVAR_BULK:
		case CAMPANHA_RESGATE_REPROVAR_BULK:
			return { ...state, mudancaStatusBulk: action.payload };
		default:
			return state
	}
}